export default "__VITE_ASSET__D9rcs_HJ__"